import type { Key } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Select } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { useApiQuery } from "../api-client";

export interface IStreamsSelectProps {
    connectionId: number;
    isDisabled?: boolean;
    onStreamChange: (streamId: string | undefined) => void;
    propertyId: string;
    streamId?: string;
}

export const GaStreamsSelect = ({
    connectionId,
    isDisabled,
    onStreamChange,
    propertyId,
    streamId,
}: IStreamsSelectProps) => {
    const { translate } = useTranslate();
    const {
        data: streams = [],
        isLoading,
        isError,
    } = useApiQuery(
        {
            tag: "GoogleAnalyticsMapping",
            methodName: "v1GoogleConnectionsGoogleAnalyticsStreamsDetail",
        },
        connectionId,
        propertyId,
    );

    const onSelectionChange = (streamId: Key | null) => {
        onStreamChange(streamId?.toString() || undefined);
    };

    return (
        <Stack gap="4px">
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon[300]}
            >
                {translate("ga-connect.connection.select-data-stream")}
            </Text>
            <Select
                items={streams}
                placeholder={translate("ga-connect.connection.select-data-stream-placeholder")}
                onSelectionChange={onSelectionChange}
                selectedKey={streamId}
                isDisabled={isLoading || !streams.length || isDisabled}
                isInvalid={isError}
                errorMessage={translate("ga-connect.connection.select-data-stream.loading-error")}
            >
                {(stream) => (
                    <Select.Item
                        textValue={stream.id}
                        id={stream.id}
                    >
                        {stream.displayName}
                    </Select.Item>
                )}
            </Select>
        </Stack>
    );
};
